import { Tooltip } from '@trackman/web-shared-components';
import { ReactComponent as TopInning } from 'images/topInning.svg';
import { useStores } from 'index';
import { observer } from 'mobx-react-lite';
import React, { useEffect, useState } from 'react';
import { BottomInning, DataItem, DataLabel, DataValue, DataWrapper, InningWrapper, ModeBadge } from './SessionDataStyles';

export const SessionData = observer(() => {
  const displayDataStore = useStores().displayDataStore;
  const notificationsStore = useStores().notificationsStore;
  const [sessionMode, setSessionMode] = useState(displayDataStore.playData?.sessionMode || 'WarmupStarted'); // === 'WarmupStarted' || 'PlayingStarted'

  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    if (displayDataStore.playData?.sessionMode !== sessionMode) {
      if (initialized) {
        notificationsStore.addToast(
          '',
          `Game status has changed to ${displayDataStore.playData?.sessionMode === 'WarmupStarted' ? '"Warmup"' : '"Live"'}`,
          'info'
        );

        setSessionMode(displayDataStore.playData?.sessionMode);
      }
      setInitialized(true);
    }

    return () => {
      setInitialized(false);
    };
  }, [displayDataStore.playData]);

  return (
    <DataWrapper>
      <DataItem data-testid='session-mode'>
        <DataLabel>Mode</DataLabel>
        <ModeBadge isPlaying={sessionMode === 'PlayingStarted'}>{sessionMode === 'PlayingStarted' ? 'Live' : 'Warmup'}</ModeBadge>
      </DataItem>
      <DataItem data-testid='inning'>
        <DataLabel>Inning</DataLabel>
        <DataValue>
          {displayDataStore.playData?.inning?.inningNumber}{' '}
          <InningWrapper>{displayDataStore.playData?.inning?.isTopInning ? <TopInning /> : <BottomInning />}</InningWrapper>
        </DataValue>
      </DataItem>
      <DataItem data-testid='pitcher'>
        <DataLabel>Pitcher</DataLabel>
        <Tooltip
          title={displayDataStore.playData?.pitcher?.name}
          placement='bottom'
          content='Pitcher'
          children={<DataValue>{displayDataStore.playData?.pitcher?.name}</DataValue>}
        />
      </DataItem>
      <DataItem data-testid='pitcher-dex'>
        <DataLabel>P.Dex</DataLabel>
        <DataValue>{displayDataStore.playData?.pitcher?.handedness}</DataValue>
      </DataItem>
      <DataItem data-testid='batter'>
        <DataLabel>Batter</DataLabel>
        <Tooltip
          title={displayDataStore.playData?.batter?.name || ''}
          children={<DataValue>{displayDataStore.playData?.batter?.name}</DataValue>}
        />
      </DataItem>
      <DataItem data-testid='batter-dex'>
        <DataLabel>B.Dex</DataLabel>
        <DataValue>{displayDataStore.playData?.batter?.handedness}</DataValue>
      </DataItem>
    </DataWrapper>
  );
});
